/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import ApiService from 'cio/services/api';
import AnalyticsService from 'cio/services/analytics';

interface WorkspaceSettingArgs {
  setting: 'anonymous_events_merge' | 'tracked_links_append_internal' | 'auto_merge';
}

export default class WorkspaceSetting extends Component<WorkspaceSettingArgs> {
  @service api!: ApiService;
  @service analytics!: AnalyticsService;

  @tracked isEnabled = false;

  getSettingTask = dropTask(async () => {
    let { enabled } = await this.api.request(this.args.setting);
    this.isEnabled = enabled;
  });

  toggleSettingTask = dropTask(async () => {
    let enabled = !this.isEnabled;

    await this.api.post(this.args.setting, { data: { enabled } });
    this.isEnabled = enabled;

    if (this.args.setting === 'anonymous_events_merge') {
      this.analytics.track('workspace', enabled ? 'anonymous_events_merge_enabled' : 'anonymous_events_merge_disabled');
    } else if (this.args.setting === 'tracked_links_append_internal') {
      this.analytics.track(
        'workspace',
        enabled ? 'auto_identify_track_links_enabled' : 'auto_identify_track_links_disabled',
      );
    } else if (this.args.setting === 'auto_merge') {
      this.analytics.track('workspace', enabled ? 'auto_merge_enabled' : 'auto_merge_disabled');
    }
  });

  constructor(owner: unknown, args: WorkspaceSettingArgs) {
    super(owner, args);
    this.getSettingTask.perform();
  }
}
